import FormValidation from '../form/form-validation';

const imageInputs = [
  {
    id: `#catalog_item_update_logo_id`,
    preview: '.js-preview-logo',
  },
  {
    id: `#catalog_item_update_logo_icon_id`,
    preview: '.js-preview-logo_icon',
  },
  {
    id: `#catalog_item_update_product_image_id`,
    preview: '.js-preview-product_image',
  },
  {
    id: `#catalog_item_update_featured_image_id`,
    preview: '.js-preview-featured_image',
  }
];

export default class Catalog {

  constructor() {
    this.form = document.getElementById('catalog_item_update');

    if (this.form) {
      window.solodev.submitForm = () => this.form.submit();

      imageInputs.forEach((input) => {
        this.initCatalogImagesActions(input);
      });

      this.checkFieldsToDisplay();

      const categoryAccordion = document.getElementById('accordionCategories');
      if (categoryAccordion) {
        this.initCategories();
      }
    }

    this.catalogTransferGroup = document.querySelector('.js-catalog-transfer');
    this.catalogTransferGroup && this.initTransferCatalog( this.catalogTransferGroup );
  }

  // Check category when clicked on containing div.
  initCategories() {
    const categoryItems = document.querySelectorAll('.js-category-item');
    categoryItems.forEach((el) => {
      el.addEventListener('click', (e) => {
        if (e.target.tagName !== 'INPUT' && e.target.tagName !== 'LABEL') {
          const input = e.target.querySelector('input');
          input.checked = !input.checked;
        }
      });
    });
  }

  initCatalogImagesActions(input) {
    const inputFile = document.querySelector(input.id),
    imagePreview = document.querySelector(input.preview),
    inputSpan = inputFile.parentNode.parentNode.querySelector('span.file-upload'),
    resetButton = inputFile.parentNode.querySelector('.js-reset-image'),
    form = new FormValidation();

    form.imageExtensionChecker(inputFile, this.imagePreviewAction.bind(this, inputFile, imagePreview));

    resetButton.addEventListener('click', ( e ) => {
      e.preventDefault();

      if (window.confirm('Are you sure you want to delete this image? It will be removed after Save.')) {
        const form = document.getElementById('catalog_item_update'),
        dataImageInput = form.querySelector('#catalog_item_update_deleted_images'),
        inputValue = JSON.parse(dataImageInput.value || '[]');

        // remove delete button and image preview
        resetButton.classList.add('d-none');
        inputSpan.innerText = 'No file chosen';
        inputSpan.classList.remove('text-color1');
        imagePreview.classList.add('d-none');
        inputSpan.previousElementSibling.classList.remove('w-xs-210p');
        inputSpan.previousElementSibling.classList.add('w-xs-160p');

        inputValue.push(resetButton.getAttribute('data-image'));
        dataImageInput.value = JSON.stringify(inputValue);
      }
    });

    // Add file name to span on preview
    inputFile.onchange = (e) => {
      resetButton.classList.remove('d-none');
      inputSpan.innerText = e.target.files[0].name;
      inputSpan.classList.add('text-color1');
      inputSpan.previousElementSibling.classList.add('w-xs-210p');
      inputSpan.previousElementSibling.classList.remove('w-xs-160p');
    };

    // Add file name to span after save/on load
    const imageSrcSplit = imagePreview.src.split('/');
    if (imageSrcSplit[3] == 'file') {
      const imgUrl = imageSrcSplit.slice(-1);
      inputSpan.innerText = imgUrl;
      inputSpan.classList.remove('d-none');
      inputSpan.classList.add('text-color1');
    }
  }

  imagePreviewAction = (inputFile, imagePreview) => {
    const reader = new FileReader();
    reader.onload = (e) => {
      imagePreview.src = e.target.result;
      imagePreview.parentNode.parentNode.classList.remove('d-none');
    }
    reader.readAsDataURL(inputFile.files[0]);
  }

  // Show / hide fields based on catalog type
  checkFieldsToDisplay() {
    const catalogFulfillmentType = this.form.dataset.type;

    const formSpecs = document.querySelector('.form_specs');

    if (['service','provider'].includes(catalogFulfillmentType)) {
      formSpecs.classList.remove('d-none');
    } else if (['theme','module','app'].includes(catalogFulfillmentType)) {
      formSpecs.classList.add('d-none');
    } else if (['nft', 'coin'].includes(catalogFulfillmentType)) {
      formSpecs.classList.add('d-none');
    } else {
      formSpecs.classList.add('d-none');
    }
  }

  initTransferCatalog( transferGroup ) {
    const select = transferGroup.querySelector('select#catalog');
    const button = transferGroup.querySelector('.transfer_catalog');

    if (!select || !button ) return;

    const { transferUrl } = select.dataset;

    button.addEventListener('click', () => {
      $.ajax({
        url: transferUrl,
        type: 'post',
          data: {
          catalog_id: select.value,
        },
        success: ( data ) => {
          top.document.location = data.url;
          top.closeAction();
        }
      });
    });
  }
}
